import React from 'react';
import { I18n } from '@aws-amplify/core';
import * as S from '@/components/Settings/DataExtraction/styles';
import * as FormStyles from './styles';

export function InitialDateFormItem() {
	return (
		<S.CustomFormItem
			label={I18n.get('Start reference date')}
			name={['general_information', 'initial_date']}
			labelCol={{ span: 24 }}
		>
			<FormStyles.CustomDatePicker
				format="L"
				placeholder={I18n.get('Date')}
				disabledDate={(current) => current && current.valueOf() > Date.now()}
			/>
		</S.CustomFormItem>
	);
}
